module.exports = __webpack_public_path__ + "img/2.70e7f13c.jpg";